module.exports = __webpack_public_path__ + "8099f57d1b716d6505a937efd0275082.pdf";